(function () {
    'use strict';

    function excludeSelectedProducts() {
        return function (items, productQualifications) {
            var allProductIds = _.map(productQualifications, (function (productQualification) {
                return productQualification.Product.Id;
            }));

            var filteredData = [];
            angular.forEach(items, function (item) {
                if (!(_.include(allProductIds, item.Id))) {
                    filteredData.push(item);
                }
            });
            return filteredData;
        };
    }

    angular.module('ecap.workflow').filter('excludeSelectedProducts', excludeSelectedProducts);
})();
